import React, { useEffect } from "react";
import {
  Box,
  Typography,
  RadioGroup,
  FormControlLabel,
  Button,
} from "@mui/material";
import RadioControl from "../../../elements/RadioControl";
import { ErrorBox } from "../../../elements/ErrorBox";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

interface IJobState {
  [key: string]: string;
}

type TPostJobStep1Props = {
  jobState: any;
  jobStep: number;
  rebookJob?: any;
  responseError: string | null;
  handleUpdateJobState: (data: IJobState) => void;
  changeStep: (step: number) => void;
};

export const PostJobStep1 = ({
  jobState,
  handleUpdateJobState,
  changeStep,
  jobStep,
  responseError,
  rebookJob,
}: TPostJobStep1Props) => {
  const {
    control,
    handleSubmit,
    setValue,
  } = useForm({
    defaultValues: {
      repeats: jobState?.repeats === true || jobState?.repeats === "true" ? "true" : "false",
    },
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    if (rebookJob) {
      setValue("repeats", rebookJob?.repeats);
    }
  }, [rebookJob]);

  const onSubmit = async (data: any): Promise<any> => {
    handleUpdateJobState(data);
    changeStep(jobStep + 1);
  };

  return (
    <>
      <Box sx={{ width: "100%", mb: "32px" }}>
        <Typography
          align="center"
          variant="h2"
          sx={{
            mb: "32px",
          }}
        >
          Frequency of work
        </Typography>
        <Box
          sx={{
            mb: "48px",
          }}
        >
          <Controller
            rules={{ required: true }}
            control={control}
            name="repeats"
            render={({ field }) => (
              <RadioGroup {...field}>
                {["One-time job", "Recurring job"].map((item: any, id: any) => (
                  <FormControlLabel
                    key={id}
                    control={
                      <RadioControl
                        value={item === "One-time job" ? "false" : "true"}
                      />
                    }
                    label={item}
                  />
                ))}
              </RadioGroup>
            )}
          />
        </Box>
        {responseError && (
          <ErrorBox
            sx={{
              mt: "8px",
              display: "flex",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            {responseError}
          </ErrorBox>
        )}
      </Box>
      <Box sx={{ display: "flex", width: "100%" }}>
        <Button fullWidth variant="lucky" onClick={handleSubmit(onSubmit)}>
          Next step
        </Button>
      </Box>
    </>
  );
};

const schema = yup.object().shape({
  repeats: yup.string().required("Type is required"),
});
